import * as LotTypeActionType from './constants';
import * as CommonActionType from '../Common/constants';

const defaultParams = {
  projectId: '',
  searchKey: '',
  skip: 1,
  take: 10,
  sort: { field: 'projectName', order: 'ascending' },
  status: 'all',
  totalRecord: 0,
  totalPage: 0
};

const ManageLots = {
  items: [],
  params: defaultParams
};

const ManageRFSLot = {
  items: [],
  params: {
    searchKey: '',
    skip: 1,
    take: 100,
    sortField: 'refNo',
    sortOrder: 'descending',
    status: ''
  }
};

const LotState = {
  SelectListPhases: [],
  SelectListModels: [],
  SelectListInsurances: [],
  SelectListProjects: [],
  SelectListCostCodes: [],
  ManageLots: ManageLots,
  ErrorMsg: [],
  dateTime: new Date(),
  IsSuccessStep3: false,
  IsSuccessImport: false,
  ImportSuccessResult: [],
  ImportErrorResult: [],
  isSuccessCreatedUpdated: false,
  RoomList: [],
  TradeList: [],
  LotProfile: {},
  HomeownerLots: [],
  ManageRFSLot: ManageRFSLot,
  LotAWSCredential: null,
  LotDocuments: [],
  LotNotes: [],
  LotLocations: [],
  HomeownerLotSelectList: [],
  HomeownerDocumentTypes: [],
  HomeownerDocuments: [],
  categoryList: [],
  categoryItemList: []
};

export default function LotStore(state = LotState, action) {
  switch (action.type) {
    case CommonActionType.COMMON_SELECT_LIST_PHASE_SUCCESS:
      return processSelectListPhases(state, action);
    case CommonActionType.COMMON_SELECT_LIST_INSURANCE_SUCCESS:
      return processSelectListInsurances(state, action);
    case CommonActionType.COMMON_SELECT_LIST_MODEL_SUCCESS:
      return processSelectListModels(state, action);
    case CommonActionType.COMMON_SELECT_LIST_PROJECT_SUCCESS:
      return processSelectListProjects(state, action);
    case LotTypeActionType.SEARCH_LOT_SUCCESS:
      return processSearchSuccess(state, action);
    case LotTypeActionType.GET_LOT_BY_ID_SUCCESS:
      return processGetByIdSuccess(state, action);
    case LotTypeActionType.CREATE_UPDATE_SUCCESS:
      return processCreateUpdateSuccess(state);

    case LotTypeActionType.CREATE_UPDATE_LOT_ERROR:
      return {
        ...state,
        ErrorMsg: [action.data.error]
      };
    case LotTypeActionType.IMPORT_LOT_ASYNC:
      return {
        ...state,
        IsSuccessImport: false,
        ImportSuccessResult: [],
        ImportErrorResult: []
      };
    case LotTypeActionType.IMPORT_LOT_SUCCESS:
      return processImportSuccess(state, action);
    case LotTypeActionType.IMPORT_LOT_FAIL:
      return processImportFail(state, action);
    case LotTypeActionType.RESET_LOT_UPDATED:
      return {
        ...state,
        isSuccessCreatedUpdated: false
      };
    case LotTypeActionType.RESET_LOT:
      return {
        ...state,
        ManageLots: ManageLots,
        SelectListPhases: [],
        SelectListModels: [],
        SelectListProjects: [],
        ErrorMsg: [],
        dateTime: new Date(),
        IsSuccessStep3: false,
        IsSuccessImport: false,
        ImportSuccessResult: [],
        ImportErrorResult: [],
        isSuccessCreatedUpdated: false
      };
    case LotTypeActionType.SELECT_ROOM_SUCCESS:
      return processSelectRoomSuccess(state, action);
    case LotTypeActionType.SELECT_TRADE_SUCCESS:
      return processSelectTradeSuccess(state, action);
    case LotTypeActionType.GET_HOMEOWNER_LOT_LIST_ASYNC:
      return {
        ...state,
        HomeownerLots: []
      };
    case LotTypeActionType.GET_LIST_COST_CODE_SUCCESS:
      return {
        ...state,
        SelectListCostCodes: action.data
      };

    case LotTypeActionType.GET_HOMEOWNER_LOT_LIST_SUCCESS:
      return {
        ...state,
        HomeownerLots: action.data
      };
    case LotTypeActionType.RESET_LOT_PROFILE:
      return {
        ...state,
        LotProfile: null
      };
    case LotTypeActionType.SEARCH_RFS_LOT_SUCCESS:
      var result = action.data;
      var manageRFSLot = {
        items: result.data.items,
        params: {
          ...state.ManageRFSLot.params,
          totalRecord: result.data.totalRecord,
          totalPage: result.data.totalPage
        }
      };
      return {
        ...state,
        ManageRFSLot: manageRFSLot
      };
    case LotTypeActionType.RESET_RFS_LOT:
      return {
        ...state,
        ManageRFSLot: ManageRFSLot
      };
    case LotTypeActionType.SETUP_LOT_DOCUMENT_AWS_SUCCESS:
      return {
        ...state,
        LotAWSCredential: action.data
      };
    case LotTypeActionType.UPLOAD_LOT_DOCUMENT_TO_SERVER_SUCCESS:
      return {
        ...state,
        LotDocuments: [...state.LotDocuments, ...action.data]
      };
    case LotTypeActionType.GET_LOT_DOCUMENT_SUCCESS:
      return {
        ...state,
        LotDocuments: action.data
      };
    case LotTypeActionType.RESET_LOT_DOCUMENT:
      return {
        ...state,
        LotDocuments: []
      };
    case LotTypeActionType.GET_LOT_NOTES_SUCCESS:
      return {
        ...state,
        LotNotes: action.data
      };
    case LotTypeActionType.GET_LOT_LOCATIONS_SUCCESS:
      return {
        ...state,
        LotLocations: action.data
      };
    case LotTypeActionType.RESET_LOT_LOCATIONS:
      return {
        ...state,
        LotLocations: []
      };
    case LotTypeActionType.GET_SELECT_LIST_HOMEOWNER_LOT_SUCCESS:
      return {
        ...state,
        HomeownerLotSelectList: action.data
      };
    case LotTypeActionType.GET_LIST_HOMEOWNER_DOCUMENT_TYPE_SUCCESS:
      return {
        ...state,
        HomeownerDocumentTypes: action.data
      };
    case LotTypeActionType.GET_HOMEOWNER_DOCUMENT_BY_DOCUMENT_TYPE_SUCCESS:
      return {
        ...state,
        HomeownerDocuments: action.data
      };
    case LotTypeActionType.GET_LIST_CATEGORY_HOME_INVENTORY_HOME_OWNER_SUCCESS:
      return {
        ...state,
        categoryList: action.data
      };
    case LotTypeActionType.GET_LIST_CATEGORY_ITEM_HOME_INVENTORY_HOME_OWNER_SUCCESS:
      return {
        ...state,
        categoryItemList: action.data
      };
    case LotTypeActionType.GET_CATEGORY_ITEM_HOME_INVENTORY_PROFILE_HOME_OWNER_SUCCESS:
      return {
        ...state,
        categoryItemProfile: action.data
      };
    case LotTypeActionType.GET_CATEGORY_PROFILE_DETAILS_HOME_OWNER_SUCCESS:
      return {
        ...state,
        CategoryProfile: action.data
      };
    case LotTypeActionType.GET_TASK_REMINDER_LIST_FOR_HOMEOWNER_SUCCESS:
      return {
        ...state,
        MaintenanceTaskReminderList: action.data
      };

    default:
      return state;
  }
}

const processSelectListPhases = (state, action) => {
  return {
    ...state,
    SelectListPhases: action.data
  };
};

const processSelectListInsurances = (state, action) => {
  return {
    ...state,
    SelectListInsurances: action.data
  };
};

const processSelectListModels = (state, action) => {
  return {
    ...state,
    SelectListModels: action.data
  };
};

const processSelectListProjects = (state, action) => {
  return {
    ...state,
    SelectListProjects: action.data
  };
};

const processImportSuccess = (state, action) => {
  return {
    ...state,
    ImportSuccessResult: action.data,
    ErrorMsg: [],
    IsSuccessImport: true,
    ImportErrorResult: []
  };
};

const processGetByIdSuccess = (state, action) => {
  return {
    ...state,
    LotProfile: action.data,
    ErrorMsg: [],
    IsCreate: false
  };
};

const processCreateUpdateSuccess = (state) => {
  return {
    ...state,
    isSuccessCreatedUpdated: true,
    ErrorMsg: []
  };
};

const processImportFail = (state, action) => {
  if (action.data['items']) {
    return {
      ...state,
      ImportErrorResult: action.data,
      ErrorMsg: [],
      IsSuccessImport: false
    };
  } else {

    return {
      ...state,
      ErrorMsg: [action.data],
      IsSuccessImport: false
    };
  }

};

const processSearchSuccess = (state, action) => {
  var result = action.data;
  var manageLots = {
    items: result.data.items,
    params: {
      ...state.ManageLots.params,
      skip: action.data.params.skip + 1,
      take: action.data.params.take,
      sort: { field: action.data.params.sortField, order: action.data.params.sortOrder },
      totalRecord: result.data.totalRecord,
      totalPage: result.data.totalPage
    }
  };
  return {
    ...state,
    ManageLots: manageLots,
    ErrorMsg: []
  };
};

const processSelectRoomSuccess = (state, action) => {
  // let roomList = [...state.RoomList];
  // action.data.map((item) => {
  //   if (roomList.filter(e => e.value === item.value).length === 0) {
  //     roomList.push(item);
  //   }
  // });

  return {
    ...state,
    RoomList: action.data
  };
};

const processSelectTradeSuccess = (state, action) => {
  // let tradeList = [...state.TradeList];
  // action.data.map((item) => {
  //   if (tradeList.filter(e => e.value === item.value).length === 0) {
  //     tradeList.push(item);
  //   }
  // });

  return {
    ...state,
    TradeList: action.data
  };
};



// WEBPACK FOOTER //
// ./src/Lots/reducers.js